<!--  -->
<template>
  <van-popup class="popupDraw" v-model="show" :round="true" @click-overlay="close">
    <div class="gift">
      <img
        class="bg"
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/stresstest/giftbg.png"
      />
      <div class="look">
        <img @click="look1" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/stresstest/see.png" />
        <img @click="look2" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/stresstest/see.png" />
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: true,
    };
  },
  props: ['productId'],
  computed: {},
  watch: {},
  methods: {
    look1() {
      this.$router.push({
        path: '/personalCenter/myCoupon',
      });
    },
    look2() {
      this.$router.push({
        path: `/courseDetail?courseId=${this.productId}&beforePageName=1`,
      });
    },
    close() {
      this.$parent.showReward = false;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.popupDraw {
  background: none;
  border-radius: 36px !important;
}
.gift {
  position: relative;
  // width: 600px;
  // height: 680px;
  // border-radius: 30px;
  // padding-top: 1px;
  // background-color: #fff;
  .bg {
    display: block;
    width: 604px;
    height: 760px;
    margin: 0 auto;
  }
  .look {
    position: absolute;
    left:0;
    right:0;
    bottom: 40px;
    margin:0 auto;
    display: flex;
    justify-content: center;
    img {
      display: block;
      width: 208px;
      height: 80px;
      margin: 0 20px;
    }
  }
}
</style>
